module.exports = __webpack_public_path__ + "static/media/min-logo.bad89c9d.svg";